import background1 from "../assets/backgrounds/group-covers/cover1.svg";
import background2 from "../assets/backgrounds/group-covers/cover2.svg";
import background3 from "../assets/backgrounds/group-covers/cover3.svg";
import background4 from "../assets/backgrounds/group-covers/cover4.svg";

export const getRandomBg = () => {
  const backgrounds = [background1, background2, background3, background4];
  return backgrounds[Math.floor(Math.random() * backgrounds.length)];
};
